import { EnumDescriptor } from './enum-descriptor';

export enum StoryState {
  Draft = 10,
  Published = 20,
}

export const storyStateDescriptor = new EnumDescriptor(StoryState);
